
import pathStore from '../store/pathStore';
import treeStore from '../store/treeStore';
import { saveAs } from 'file-saver';
import userStore from '../store/userStore';
import { addNotification } from '../action/notificationAction';


/**
 * csv manager, flattens the tree then starts building a CSV format and emits a file
 */
export function csvManager() {
    const keys = Object.keys(treeStore.tree);

    const kLength = keys.length;
    let csvString = 'SubsiteName, SubsiteURL, DLName, DLUrl ,DLSource1, DLSource2,DLSource3,DLSource4,DLSource5,DLSource6,DLSource7,DLSource8,DLSource9,DLSource10,DLSource11,DLSource12,DLSource13,DLSource14,DLSource15\n';
    //Loops through the list of keys in the treestore
    for (let i = 0; i < kLength; i++) {
        const node = treeStore.tree[keys[i]];
        //checks if its a site or hub
        if (node.type === "hub" || node.type === "site") {
            let tempString = node.name + "," + node.shortName + ', , , , , , , , , , , , , , , ,   \n';
            //does it find any children
            let didFind = false;
            for (let j = 0; j < kLength; j++) {
                const childNode = treeStore.tree[keys[j]];
                /**Loops through and checks for any children which are a docLib */
                if (childNode.parent === node.id && childNode.type === "docLib") {
                    didFind = true;
                    tempString += node.name + "," + node.shortName + "," + childNode.name + "," + childNode.shortName + ",";
                    for (let i = 0; i < 15; i++) {
                        // checks if the source exists or the exist at that position exists
                        //if it doesnt exist returns an empty entry
                        if (childNode.sources) {
                            const docLib = childNode.sources[i];
                            if (docLib !== undefined) {
                                tempString += childNode.sources[i].path + ",";
                            } else {
                                tempString += `,`;
                            }
                        } else {
                            tempString += `,`;
                        }

                        if (i === 14) {
                            tempString += "\n";
                        }
                    }
                }
            }
            /**if found append to string */
            if (didFind) {
                csvString += tempString;
            }
        }
    }
    try {
        const file = new Blob([csvString], { type: 'text/csv;charset=utf-8' });
        saveAs(file, `sitesBy${userStore.user.email}.csv`);
        addNotification({ status: "success", message: "CSV completed" });
    } catch (error) {
        addNotification({ status: "fail", message: "CSV Failed, please try again" });
    }
}
/**
 * builds the url for children of a parent
 * @param {} tree the tree of data to root through
 
function URLBuilder(tree) {
    let rootTree = [];
    let children = {};
    let urlData = [];
    tree.forEach((tree) => {
        let item = treeStore.tree[tree],
            parent = item.parent,
            target = !parent ? rootTree : (children[parent] || (children[parent] = []));

        target.push(item);
    })

    /**
     * recurisive funciton that finds the children of a node
     * @param {*} parent parent object
     * @param {*} pUrl parent url
     
    let findChildren = (parent, pUrl) => {
        if (children[parent.id]) {
            children[parent.id].forEach((child => {
                let url = `${pUrl}/${child.shortName}`;
                //console.log(url);
                child.url = url;
                urlData.push(child);
                findChildren(child, url);
            }))
        }
    }
    children[0].forEach((child) => {
        let url = `${child.shortName}`;
        child.url = url;
        urlData.push(child);
        findChildren(child, url);
    })

    return urlData;

}
*/

/**
 * flattens the tree object down to assists with helping stuff be built in the cvs in the right order
 */
export function flattenTree() {
    return new Promise((resolve) => {
        let flattenTree = [];
        let relationshipTree = pathStore.relationship;
        let lengthTree = Object.keys(relationshipTree).length;
        let counter = 0;
        Object.keys(relationshipTree).forEach((relKey) => {
            counter++;
            parentFinder(relationshipTree[relKey].parent, relationshipTree).then((parent) => {
                if (parent !== null) {
                    childFinder(parent);
                }
            }).catch(() => {
                if (lengthTree === counter) {
                    //console.log(flattenTree);
                }
            });
        });
        /**
         * recurisive function that flattens the tree down to have a order 
         * @param {*} parent parent object
         */
        let childFinder = function (parent) {
            if (parent.children) {
                let add = true;
                parent.children.forEach((child) => {
                    flattenTree.forEach((treeId) => {
                        if (treeId === child) {
                            add = false;
                        }
                    });
                    if (add) {
                        // let parentShort =treeStore.tree[parent.id].shortName;
                        // let childShort =treeStore.tree[child].shortName;
                        // let url = `${parentShort}/${childShort}`;
                        // console.log(url)
                        // let obj = {
                        //     id: child,
                        //     url: url
                        // }
                        // console.log(obj);
                        flattenTree.push(child);
                    }
                    parentFinder(child, relationshipTree).then((parent) => {
                        if (parent === null) {
                            return resolve(flattenTree);
                        }
                        childFinder(parent);
                    }).catch(() => {
                        if (lengthTree === counter) {
                            // flattenTree.forEach((id)=>{
                            //     console.log(treeStore.tree[id].name);
                            // })
                            return resolve(flattenTree);
                        }
                    });
                });
            }
        };
    });
}
/**
 * finds all the parent nodes
 * @param {*} parentId parent id
 * @param {*} relationshipTree the relationship tree
 */
function parentFinder(parentId, relationshipTree) {
    return new Promise((resolve, reject) => {
        Object.keys(relationshipTree).forEach((relKey) => {
            if (relationshipTree[relKey].parent === parentId) {
                return resolve(relationshipTree[relKey]);
            }
        });
        return reject("fail");
    });
}



// WEBPACK FOOTER //
// ./src/services/csvManager.js